// Copyright (c) Docugami, Inc. All rights reserved.

import { DefaultButton } from "@fluentui/react";

interface SelectionTextProps {
    hidden?: boolean;
    count?: number;
    onClear?: () => void;
}

export const SelectionCountButton = (props: SelectionTextProps): JSX.Element | null => {
    if (!!props.hidden || !props.count) {
        return null;
    }

    return (
        <DefaultButton
            text={`${props.count} selected`}
            styles={{ root: { border: 'none' } }}
            iconProps={{ iconName: 'ChromeClose', styles: { root: { fontSize: '10px' } } }}
            onClick={props.onClear} />
    )
}